
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import img5 from '../../assets/3d-stopwatch 1.png';
import img6 from '../../assets/rupee (1) 3.png';
import { ApiManager } from '../../utils/apiManager';
import { offerMappingService, OfferData } from '../../utils/offerMapping';

interface PayBannerProps {
  onBannerStateChange: (isVisible: boolean) => void;
}

export default function PayBanner({ onBannerStateChange }: PayBannerProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const checkInstantPay = async () => {
      try {
        const currentUrl = window.location.pathname;
        const match = currentUrl.match(/\/(\d+)\/?$/);
        const urlNumber = match ? match[1] : '0';

        const response = await ApiManager.fetchWithAbort(
          `https://backend.app20.in/api/form/v2/check-form/?url=${urlNumber}`
        );

        if (response.status === 200) {
          const data = await response.json();

          if (data.active_forms && Array.isArray(data.active_forms)) {
            const activeForms: OfferData[] = data.active_forms.map((item: { url: string; name: string }) => ({
              url: item.url,
              name: item.name
            }));
            offerMappingService.updateOffers(activeForms);
          }

          const shouldShowBanner = data.instant_pay === true && isSmallScreen;
          setShowBanner(shouldShowBanner);
          onBannerStateChange(shouldShowBanner);
        }
      } catch (error) {
        // Silently handle fetch errors or warn to avoid cluttering console
        console.warn('Network issue checking instant pay status:', error);
        setShowBanner(false);
        onBannerStateChange(false);
      }
    };

    checkInstantPay();
    const bannerCheck = setInterval(checkInstantPay, 30000);

    return () => clearInterval(bannerCheck);
  }, [isSmallScreen, onBannerStateChange]);

  if (!isSmallScreen || !showBanner) return null;

  return (
    <Box
      sx={{
        width: '100%',
        height: '40px',
        background: 'linear-gradient(90deg, #FFC107 0%, #FFD740 100%)', // Yellow Gradient
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: '800',
            color: '#000', // Black text
            letterSpacing: '0.5px'
          }}
        >
          VERIFIED PAYOUTS
        </Typography>
        <img
          src={img6}
          alt="Money Icon"
          style={{ height: '18px' }}
        />
        <img
          src={img5}
          alt="Clock Icon"
          style={{ height: '18px' }}
        />
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: '800',
            color: '#000', // Black text
            letterSpacing: '0.5px'
          }}
        >
          ON THIS OFFER
        </Typography>
      </Box>
    </Box>
  );
}